// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/" + (chunkId === 85 ? "lazy-app" : chunkId) + "." + {"85":"f84967f6f6cf7a8a8df5","371":"3c37944e395ffdb19820"}[chunkId] + ".js";
};